import SignInActivityScreen from './SignInActivityScreen';

export default SignInActivityScreen;
